import { Box, Typography, useMediaQuery } from '@mui/material';
import { PaginationConfig } from '@sm-dashboard/types';
import { useSearchParams } from 'react-router-dom';
import { useTheme, Theme } from '@mui/material/styles';
import { Select } from '@sm-dashboard/ui-components';
import { PageNavigator } from './PageNavigator';

export const Pagination = (pagination: PaginationConfig) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();
  const { count, rowsPerPageOptions } = pagination;
  const currentPage = Number(searchParams.get('page')) || 0;
  const rowsPerPage = Number(searchParams.get('rowsPerPage')) || rowsPerPageOptions?.[0] || 100;
  const totalPages = Math.ceil(count / rowsPerPage);
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const onPageChange = (page: number) => {
    searchParams.set('page', page.toString());
    setSearchParams(searchParams);
  };

  const onRowsPerPageChange = (value: number) => {
    searchParams.set('rowsPerPage', value.toString());
    searchParams.set('page', '0');
    setSearchParams(searchParams);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: theme.palette.background.default,
        borderRadius: '0 0 20px 20px',
        width: '100%',
        minHeight: 55,
        padding: { xs: '0 16px', md: '0 36px' }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', md: 'row' } }}>
        <Typography
          variant="body2"
          align={isSmallScreen ? 'center' : 'left'}
          sx={{ marginRight: '8px', whiteSpace: { xs: 'nowrap', md: 'normal' } }}
        >
          שורות בעמוד:
        </Typography>
        <Select
          appearance="plain"
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
          options={(rowsPerPageOptions || [100, 200, 300, 1500, 2500, 3000]).map(option => ({ value: option, label: option }))}
          disableClearButton
        />
      </Box>

      {!!count && count > 0 && (
        <PageNavigator currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
      )}

      {!!count && count > 0 && (
        <Typography variant="body2">
          {`${currentPage * rowsPerPage + 1}–${Math.min((currentPage + 1) * rowsPerPage, count)} מתוך ${count} תוצאות`}
        </Typography>
      )}
    </Box>
  );
};

export default Pagination;
